import { DefaultModel } from "src/app/core/framework/default.model";
import { OpcaoResposta } from "../../resposta/opcao-resposta.model";
import { QuestaoDTO } from "./dto/questao-com-status-respondida.model";
import { TipoItemQuestionario } from "./tipo-item-questionario.enum";

export class Questao extends DefaultModel  {

  nome: string;

  tipo: TipoItemQuestionario;

  opcoes: OpcaoResposta[];

  idExterno: string;

  prerequisitoHm: string;

  obrigatorio: boolean;

  sugerir: boolean;

  ordem: number;

  // questaoRespondida?: boolean;

  descricao: string;

  // sugerir: boolean;

  // ordemGrupoQuestao: number;

  destaque: boolean;

  static getQuestaoRespondida(questao: Questao): QuestaoDTO {
    let q = null;
    q = Object.assign({}, q, questao);
    q.questaoRespondida = false;
    return q;
  }
}